import { render } from "./MyRecommendations.vue?vue&type=template&id=656eae54"
import script from "./MyRecommendations.vue?vue&type=script&lang=js"
export * from "./MyRecommendations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__